import React, { useState, useRef } from "react";
import "./faq.css";
import abs from "../../assets/abs-ques.png";
import pre_preg from "../../assets/pregnancytest.jpg";
import in_preg from "../../assets/postpreg.jpg";
import post_preg from "../../assets/inpregg.jpg";
import { Helmet } from "react-helmet";
function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const containerFaqRef = useRef(null);
  const containerFaq1Ref = useRef(null);
  const containerFaq2Ref = useRef(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "1. What are the early signs of pregnancy?",
      answer:
        "Early signs of pregnancy may include a missed period, nausea (morning sickness), fatigue, tender or swollen breasts, frequent urination, and mood swings. Some women might also notice light spotting or experience cramping.",
    },
    {
      question: "2. How early can I take a pregnancy test?",
      answer:
        "Home pregnancy tests can typically detect pregnancy about 1-2 weeks after a missed period. Testing too early may lead to inaccurate results.",
    },
    {
      question: "3. How much weight should I gain during pregnancy?",
      answer:
        "The amount of weight you should gain depends on your pre-pregnancy weight and overall health. Your doctor will give personalised recommendations based on your circumstances.",
    },
    {
      question: "4. What foods should I avoid during pregnancy?",
      answer:
        "Pregnant women should avoid certain foods like raw or undercooked meat, fish with high mercury levels, unpasteurised dairy, and certain types of seafood that may cause allergies.",
    },
    {
      question: "5. When should I start taking prenatal vitamins?",
      answer:
        "It’s recommended to start taking prenatal vitamins at least one month before trying to conceive. Prenatal vitamins contain essential nutrients like folic acid, which help prevent birth defects and support the health of both mother and baby.",
    },
  ];
  const faqData1 = [
    {
      question: "1. Can I exercise while pregnant?",
      answer:
        "In most cases, moderate exercise is safe and beneficial during pregnancy. Activities like walking or prenatal yoga can help with physical health and alleviate discomfort. However, it’s important to check with your doctor before starting or continuing any exercise regimen.",
    },
    {
      question: "2. Is it safe to travel during pregnancy?",
      answer:
        "In most cases, travelling during pregnancy is safe, especially in the second trimester. However, it's best to avoid long trips in the final month and consult your doctor before travelling, especially if you have any pregnancy complications like high blood pressure or gestational diabetes.",
    },
    {
      question: "3. What is a due date, and is it always accurate?",
      answer:
        "A due date is an estimate of when the baby will be born, typically calculated based on the first day of your last period or an early ultrasound. While it’s a good guideline, not all babies are born exactly, so it can vary by a week or more.",
    },
    {
      question: "4. What should I pack for the hospital when I’m in labour?",
      answer:
        "Key items to pack include comfortable clothing, toiletries, snacks, napkins, towels, soap, and any necessary medical paperwork. Don’t forget a baby outfit, nappies, and a car seat for when you’re ready to leave the hospital.",
    },
    {
      question: "5. Can I dye my hair while pregnant?",
      answer:
        "While some studies suggest that hair dye chemicals may be absorbed through the skin, there is no clear evidence to suggest it is harmful during pregnancy. Many doctors recommend waiting until the second trimester to dye your hair, as it may reduce any risk.",
    },
    {
      question: "6. How can I relieve back pain during pregnancy?",
      answer:
        "To relieve back pain, try maintaining good posture, wearing supportive shoes, using a maternity support belt, and sleeping on your side with a pillow between your knees. Gentle stretching and prenatal yoga can also help alleviate discomfort.",
    },
    {
      question: "7. Is it safe to have sex during pregnancy?",
      answer:
        "Sex is safe during pregnancy unless advised by your doctor. If you have any complications, your doctor might suggest avoiding intercourse. It’s important to always consult with your doctor before making any decisions during pregnancy.",
    },
    {
      question: "8. How can I prevent stretch marks during pregnancy?",
      answer:
        "While it's not always preventable, keeping your skin moisturised with creams or oils and gaining weight gradually may help reduce the appearance of stretch marks. Staying hydrated is also important for skin elasticity.",
    },
    {
      question: "9. When should I start preparing for labour?",
      answer:
        "It’s a good idea to start preparing for labour in the third trimester. This may include creating your birth plan, packing your hospital bag, arranging for transportation to the hospital, and ensuring your home is ready for the baby’s arrival.",
    },
    {
      question: "10. How long is the average pregnancy?",
      answer:
        "A typical pregnancy lasts about 40 weeks, measured from the first day of your last menstrual period (LMP) to the birth of the baby. It’s divided into three trimesters: the first trimester (weeks 1-12), the second trimester (weeks 13-26), and the third trimester (weeks 27-40).",
    },
    {
      question: "11. What are the signs of labour?",
      answer:
        "Signs of labour include regular contractions, cervical changes, water breaking, back pain, and increased pelvic pressure. If you experience these, contact your healthcare provider.",
    },
  ];
  const faqData2 = [
    {
      question: "1. How long does postpartum recovery take?",
      answer:
        "The physical recovery time varies, but most women will start to feel more like themselves within 6-8 weeks. However, complete recovery (both physically and emotionally) can take several months, and for some women, it might take up to a year or more.",
    },
    {
      question: "2. What should I expect in the first few weeks after birth?",
      answer:
        "The first few weeks may involve physical symptoms like vaginal bleeding (lochia), sore perineum, swelling, and possibly stitches from a tear or episiotomy. You might also experience hormone fluctuations, mood swings, and fatigue from caring for your newborn. ",
    },
    {
      question: "3. When can I start exercising after giving birth?",
      answer:
        "It’s important to get approval from your healthcare provider before beginning any exercise routine. Many women are encouraged to wait until the 6-week postpartum check-up. Gentle exercises like walking or pelvic floor exercises may be recommended earlier, depending on how you're recovering.",
    },
    {
      question: "4. Is it normal to feel emotional after childbirth?",
      answer:
        "Yes, hormonal changes, sleep deprivation, and the stress of adjusting to motherhood can contribute to mood swings, anxiety, and even feelings of sadness. 'Baby blues' are common during the first few weeks, but if you feel persistently sad, hopeless, or disconnected, it may be a sign of postpartum depression. Speak to a healthcare provider if you're concerned.",
    },
    {
      question: "5. How can I take care of my C-section incision?",
      answer:
        "Keep the incision clean and dry. Your doctor will provide specific aftercare instructions, but generally, it's important to avoid heavy lifting activities while healing. Signs of infection, such as redness, swelling, or discharge from the incision, should be reported to your doctor right away.",
    },
    {
      question: "6. How can I increase my milk supply while breastfeeding?",
      answer:
        "Frequent breastfeeding, ensuring proper latch, and staying hydrated are key to supporting milk supply. If you're struggling, consulting a lactation consultant can help with techniques to boost milk production.",
    },
    {
      question: "7. When can I resume sexual activity after childbirth?",
      answer:
        "It’s generally recommended to wait until your postpartum check-up and get clearance from your healthcare provider. You may also want to consider factors like comfort, your energy levels, and emotional readiness before resuming sexual activity.",
    },
  ];

  const scrollToContainerFaq = () => {
    containerFaqRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToContainerFaq1 = () => {
    containerFaq1Ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToContainerFaq2 = () => {
    containerFaq2Ref.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="faq-base">
        <Helmet>
          <title>Remarkable Pregnancy FAQs: Get Answers Now!</title>
          <meta
            name="description"
            content="Explore our pregnancy FAQs to empower your journey. Discover essential information tailored for moms-to-be and take charge of your pregnancy."
          />
          <meta
            name="keywords"
            content="Pregnancy Questions, Pregnancy Information, Pregnancy FAQ
"
          />
        </Helmet>
        <div className="abs-ques">
          <img src={abs} alt="Question-image" />
        </div>
        <div className="cont-head-faq">
          <h1 style={{ color: "white", fontSize: "35px" }}>
            Frequently Asked Question
          </h1>
          <p style={{ color: "whitesmoke", fontSize: "20px" }}>
            Got Questions? We've Got Answers, Everything You Need to Know, Right
            Here!
          </p>
        </div>
      </div>
      <div className="cont-show-faq">
        <div className="cont-show-head">
          <h2 style={{ textAlign: "left", fontSize: "32px", color: "#FF005A" }}>
            Questions Under Three Categories
          </h2>
          <h4 style={{ textAlign: "left" }}>Pre-Pregnancy</h4>
          <p id="p-tag-faq" style={{ color: "black", fontSize: "17px" }}>
            Pre-pregnancy info you can’t skip! The essential tips and knowledge
            to set you up for a smooth journey ahead!"
          </p>
          <h4 style={{ textAlign: "left" }}>During Pregnancy</h4>
          <p>
            Bump! Baby! & Beyond! Everything You Need to Know While Expecting!
          </p>
          <h4>Post-Pregnancy</h4>
          <p>
            Post-pregnancy facts you can't miss!!! Navigating the new normal
          </p>
        </div>
        <div
          id="cont-show-faq-1"
          data-text="Pre Pregnancy FAQ"
          onClick={scrollToContainerFaq}
        >
          <img src={pre_preg} alt="FAQ 1" />
        </div>
        <div
          id="cont-show-faq-1"
          data-text="In Pregnancy FAQ "
          onClick={scrollToContainerFaq1}
        >
          <img src={in_preg} alt="FAQ 2" />
        </div>
        <div
          id="cont-show-faq-1"
          data-text="Post Pregnancy FAQ "
          onClick={scrollToContainerFaq2}
        >
          <img src={post_preg} alt="FAQ 3" />
        </div>
      </div>
      <div id="container-faq" ref={containerFaqRef}>
        <h2 id="three-phase">Pre-Pregnancy FAQ</h2>
        <div className="actual-faq">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
            >
              <div className="faq-item-header" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-icon">
                  {openIndex === index ? "-" : "+"}
                </span>
              </div>
              <div className="faq-item-body">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
      <div id="container-faq1" ref={containerFaq1Ref}>
        <h2 id="three-phase">In-Pregnancy FAQ</h2>
        <div className="actual-faq">
          {faqData1.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
            >
              <div className="faq-item-header" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-icon">
                  {openIndex === index ? "-" : "+"}
                </span>
              </div>
              <div className="faq-item-body">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
      <div id="container-faq2" ref={containerFaq2Ref}>
        <h2 id="three-phase">Post-Pregnancy FAQ</h2>
        <div className="actual-faq">
          {faqData2.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
            >
              <div className="faq-item-header" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-icon">
                  {openIndex === index ? "-" : "+"}
                </span>
              </div>
              <div className="faq-item-body">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Faq;
